import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useConnectivityStore } from '@/connectivity/handler/connectivityStore';
import { PixelContainer } from '@/ui/pixel/PixelContainer';
import { useThemeColors } from '@/settings/handler/settingsStore';

export function OfflineScreen() {
  const { t } = useTranslation();
  const colors = useThemeColors();
  const refresh = useConnectivityStore((s) => s.refresh);
  const [checking, setChecking] = useState(false);

  return (
    <div className="flex h-full items-center justify-center px-8" style={{ backgroundColor: colors.surface }}>
      <div className="flex max-w-sm flex-col items-center">
        <h1 className="leading-none" style={{ fontSize: 52, color: colors.onSurface }}>
          {t('appName')}
        </h1>
        <h2 className="mt-7 text-center leading-tight" style={{ fontSize: 28, color: colors.onSurface }}>
          {t('offlineTitle')}
        </h2>
        <p
          className="mt-3 text-center"
          style={{ fontSize: 14, lineHeight: 1.4, color: colors.onSurface, opacity: 0.7 }}
        >
          {t('offlineMessage')}
        </p>
        <div className="mt-8">
          <PixelContainer
            radius={9}
            pixelScale={2}
            padding="14px 28px"
            backgroundColor={colors.surfaceContainerHighest}
            borderColor={colors.surfaceContainerHighest}
            onClick={
              checking
                ? undefined
                : () => {
                    setChecking(true);
                    refresh();
                    window.setTimeout(() => setChecking(false), 400);
                  }
            }
          >
            <span className="leading-none" style={{ fontSize: 22, color: colors.onSurface }}>
              {checking ? t('offlineChecking') : t('offlineRetry')}
            </span>
          </PixelContainer>
        </div>
      </div>
    </div>
  );
}
